<script lang="ts">
  import { page } from '$app/stores';
  import Navbar from '$lib/client/layout/Navbar.svelte';
  import PagesList from '$lib/client/layout/PagesList.svelte';
  import CategoriesMenu from './CategoriesMenu.svelte';

  const year = new Date().getFullYear();

  // function handleContactUs(event: Event) {
  //   event.preventDefault();
  //
  //   if (window.Crisp) {
  //     window.Crisp.chat.open();
  //   }
  // }
</script>

<Navbar shadow={false}>
  <CategoriesMenu slot="mobile-menu" />

  <div slot="mobile-navigation">
    {#if $page.data.authUser}
      <div class="d-flex border-bottom" style="height: 48px;">
        <PagesList />
      </div>
    {/if}
  </div>

  <a
    slot="logo"
    href="/"
    class="d-flex align-items-center text-decoration-none"
    style="width: max-content; gap: 0.875rem;"
  >
    <img class="logo" src="/images/logo.svg" width="32" height="32" alt="" />
    <p class="fs-bold text-dark h6 text-center mt-2"><span translate="no" class="notranslate">ITAD Auctions</span></p>
  </a>
</Navbar>

<main id="page" class="flex-shrink-0 flex-grow-1 py-2 mt-2 mt-sm-4 mb-5 z-0">
  <div class="container">
    <slot />
  </div>
</main>

<footer class="mt-auto py-3 bg-body-tertiary border">
  <div class="container py-3">
    <div class="d-flex flex-column text-center">
      <nav class="mx-auto">
        <ul class="d-flex flex-column flex-sm-row gap-4 list-unstyled">
          <li>
            <a href="/" class="text-body-secondary">Home</a>
          </li>
          <li>
            <a href="/about" class="text-body-secondary">About & Contact</a>
          </li>
          <li>
            <a href="/fees" class="text-body-secondary">Fees</a>
          </li>
          <li>
            <a href="/terms" class="text-body-secondary">Terms & Conditions</a>
          </li>
          <li>
            <a href="/privacy-policy" class="text-body-secondary">Privacy Policy</a>
          </li>
          <li>
            <a rel="external" target="_blank" href="https://help.itadauctions.com" class="text-body-secondary">
              Help Center
            </a>
          </li>
        </ul>
      </nav>

      <div class="d-flex flex-row gap-2 mx-auto mb-1">
        <p class="text-body-secondary">Follow us:</p>
        <a rel="external" target="_blank" href="https://www.facebook.com/61568884974468" class="text-body-secondary">
          <svg
            class="social-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.675 0H1.325C0.593 0 0 0.593 0 1.325V22.675C0 23.407 0.593 24 1.325 24H12.82V14.708H9.692V11.077H12.82V8.413C12.82 5.348 14.657 3.692 17.392 3.692C18.657 3.692 19.785 3.77 20.077 3.808V7.077H18.308C16.692 7.077 16.308 7.923 16.308 9.077V11.077H20L19.385 14.708H16.308V24H22.675C23.407 24 24 23.407 24 22.675V1.325C24 0.593 23.407 0 22.675 0Z"
              fill="#1877F2"
            />
            <path
              d="M19.385 14.708L20 11.077H16.308V9.077C16.308 7.923 16.692 7.077 18.308 7.077H20.077V3.808C19.785 3.77 18.657 3.692 17.392 3.692C14.657 3.692 12.82 5.348 12.82 8.413V11.077H9.692V14.708H12.82V24H16.308V14.708H19.385Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          rel="external"
          target="_blank"
          href="https://www.linkedin.com/company/itad-auctions"
          class="text-body-secondary"
        >
          <svg
            class="social-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.23 0H1.77C0.792 0 0 0.792 0 1.77V22.23C0 23.208 0.792 24 1.77 24H22.23C23.208 24 24 23.208 24 22.23V1.77C24 0.792 23.208 0 22.23 0ZM7.08 20.452H3.545V9.045H7.08V20.452ZM5.312 7.545C4.14 7.545 3.2 6.605 3.2 5.433C3.2 4.26 4.14 3.32 5.312 3.32C6.485 3.32 7.425 4.26 7.425 5.433C7.425 6.605 6.485 7.545 5.312 7.545ZM20.452 20.452H16.917V14.5C16.917 13.08 16.89 11.28 15.08 11.28C13.245 11.28 13 12.845 13 14.39V20.452H9.465V9.045H12.845V10.545H12.89C13.345 9.68 14.48 8.77 16.08 8.77C19.48 8.77 20.452 10.845 20.452 13.845V20.452Z"
              fill="#0A66C2"
            />
          </svg>
        </a>
      </div>

      <small class="fs-8 text-body-secondary">© {year} ITAD Auctions</small>
    </div>
  </div>
</footer>

<style>
  .social-icon {
    transition: transform 0.3s ease;
  }

  .social-icon:hover {
    transform: translateY(1px);
  }
</style>
